import { ReactElement } from 'react';
import { Route } from 'react-router';
import { SwitchWithNotFound } from '../../containers/SwitchWithNotFound';
import { NotFoundView } from '../../views/errors/NotFound.view';
import { TrainingDetailsAnnotationToolsView } from '../../views/home/trainingDetails/TrainingDetailsAnnotationTools.view';
import { TrainingDetailsDatasetsView } from '../../views/home/trainingDetails/TrainingDetailsDatasets.view';
import { TrainingDetailsImagesView } from '../../views/home/trainingDetails/TrainingDetailsImages.view';
import { TrainingDetailsMetricsView } from '../../views/home/trainingDetails/TrainingDetailsMetrics.view';
import { TrainingDetailsSettingsView } from '../../views/home/trainingDetails/TrainingDetailsSettings.view';
import { TrainingDetailsSubTrainingJobsView } from '../../views/home/trainingDetails/TrainingDetailsSubTrainingJobsView';
import { Home } from '../config/Home';

export const TrainingDetailsRoute = (): ReactElement => (
  <SwitchWithNotFound notFound={<NotFoundView />}>
    <Route path={Home.Trainings.Details.Settings.Path}>
      <TrainingDetailsSettingsView />
    </Route>
    <Route path={Home.Trainings.Details.AnnotationTools.Path}>
      <TrainingDetailsAnnotationToolsView />
    </Route>
    <Route path={Home.Trainings.Details.Datasets.Path}>
      <TrainingDetailsDatasetsView />
    </Route>
    <Route path={Home.Trainings.Details.Images.Path}>
      <TrainingDetailsImagesView />
    </Route>
    <Route path={Home.Trainings.Details.Metrics.Path}>
      <TrainingDetailsMetricsView />
    </Route>
    <Route path={Home.Trainings.Details.TrainingJobs.Path}>
      <TrainingDetailsSubTrainingJobsView />
    </Route>
  </SwitchWithNotFound>
);

export const TrainingDetailsCreateRoute = (): ReactElement => (
  <SwitchWithNotFound notFound={<NotFoundView />}>
    <Route path={Home.Trainings.Create.Settings.Path}>
      <TrainingDetailsSettingsView />
    </Route>
    <Route path={Home.Trainings.Create.AnnotationTools.Path}>
      <TrainingDetailsAnnotationToolsView />
    </Route>
    <Route path={Home.Trainings.Create.Datasets.Path}>
      <TrainingDetailsDatasetsView />
    </Route>
    <Route path={Home.Trainings.Create.Images.Path}>
      <TrainingDetailsImagesView />
    </Route>
  </SwitchWithNotFound>
);
